
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/fundraising",
      function () {
        return require("private-next-pages/features/fundraising.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/fundraising"])
      });
    }
  